/* eslint-disable max-len */
import { Text } from '@chakra-ui/react';
import TextSection from '@components/articles/SeoTextSection';
import { partBDeductible } from '@components/crm/utils/irmaa';
import { fontSize } from '@constants/styles';
import CoverageOutline from './CoverageOutline';
import Plans from './Plans';

const coverage = [
  { covered: true, name: 'Part A Coinsurance' },
  { covered: true, name: 'Part A Hospice Care Coinsurance + Copay' },
  { covered: true, name: 'Part A Deductible' },
  { covered: true, name: 'Blood (3 Pints)' },
  { covered: true, name: 'Part B Coinsurance + Copay' },
  { covered: true, name: 'Part B Excess Charge' },
  { covered: true, name: 'Part B Deductible' },
];

const PlanF = ({ renderCta, name, carriers, averagePremium }) => (
  <>
    <TextSection title={`What about Plan F in ${name}?`}>
      <Text fontSize={fontSize.p}>
        Plan F technically offers the most comprehensive coverage of all the Medicare Supplement Plans. However,
        eligibility for Plan F is closed to people who turned 65 after 2020. If you are eligible, it’s a compelling
        option, but only if the premium makes sense when comparing against Plan G.
      </Text>
      {averagePremium && (
        <Text fontSize={fontSize.p}>
          The average monthly premium for Plan F in {name} is <b>${averagePremium.toFixed(2)}</b>.
        </Text>
      )}
      <Text fontSize={fontSize.p}>Here is what Plan F offers:</Text>
      <CoverageOutline coverage={coverage} />
      {carriers.length ? (
        <Text fontSize={fontSize.p}>
          As you can see, Plan F covers even more potential out-of-pocket expenses than Plan G. <b>Pro Tip: </b>
          if your Plan F premium is $20 more than your Plan G premium, G becomes the cheaper option because the Part B
          Deductible is only ${partBDeductible}. Plan F also offers 80% coverage on foreign travel exchange, which is
          the highest on Medicare (same as Plan G). Since you’ll get this same coverage no matter the monthly premium,
          we’ve compiled the average cost of Plan F across {name}.
        </Text>
      ) : (
        <>
          <Text fontSize={fontSize.p}>
            Call us if you are interested in exploring your Plan F options. Remember: if your Plan F premium is $19 more
            than your Plan G premium, Plan G becomes the cheaper option because the Part B Deductible is only $
            {partBDeductible}. Plan F covering your Part B deductible is the only difference between it and Plan G.
          </Text>
          {renderCta()}
        </>
      )}
    </TextSection>
    {carriers.length && (
      <TextSection title={`Top 10 Cheapest Plan F Options in ${name}:`}>
        <Plans plans={carriers} />
        <Text fontSize={fontSize.p}>
          Premiums do vary by zip code, so contact us below to hear the local premiums you can actually enroll in.
        </Text>
        {renderCta()}
      </TextSection>
    )}
  </>
);

export default PlanF;
